import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useId, useRef, useState } from 'react';
import NewPage from '../common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin, changeLogId } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';
import { changeNum, formatDateTime } from '../common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function LogPoint() {
    let dark = useSelector((state) => state.Darkmode.value);
    let log_id = useSelector((state) => state.log_id.value);

    // 검색 상태
    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "");
    const [select, setSelect] = useState(false);
    const [selectValue, setSelectValue] = useState("ID");

    // 페이지네이션
    const [page, setPage] = useState(1);
    const [totalpage, setTotalPage] = useState(1);

    // 기타 상태
    const [reload, setReload] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [message, setMessage] = useState({ code: -1, msg: "" });

    // 서버에서 받아오는 데이터
    const [data, setData] = useState([]);

    // 변동량 정렬 상태 (1=오름, 2=내림, 3=기타... 로직에 따라 0→1→2→0 등)
    // 여기서는 초기값을 1로 (오름차순)
    const [changeAmt, setChangeAmt] = useState(1);

    // 날짜/시간 선택
    const [dateBtn, setDateBtn] = useState(0);
    const [selectedDate, setSelectedDate] = useState(() => {
        // 어제(D-1) 날짜
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d;
    });
    const [selectedDate1, setSelectedDate1] = useState(new Date());

    // 5개 체크박스(1=탭게임, 2=잭팟, 3=소비, 4=랜덤박스, 5=관리자리워드)
    const [checkedTapGame, setCheckedTapGame] = useState(true);    // #1 탭게임
    const [checkedJackpot, setCheckedJackpot] = useState(true);    // #2 잭팟
    const [checkedConsume, setCheckedConsume] = useState(true);    // #3 소비
    const [checkedRandom, setCheckedRandom] = useState(true);      // #4 랜덤박스
    const [checkedAdmin, setCheckedAdmin] = useState(true);        // #5 관리자리워드

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    // ------------------ 로그인 체크 ------------------
    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/');
            } else {
                dispatch(checkLogin(true));
            }
        } else {
            dispatch(checkLogin(false));
            navigate('/');
        }
    }, []);

    // ------------------ 검색 로직 ------------------
    const onChangeSearch = (e) => {
        setSearch(e.target.value);
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSubmitSearch();
        }
    };
    const onSubmitSearch = () => {
        setReload((e) => !e);
    };

    // log_id 초기화
    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""));
        }, 100);
    }, []);

    // ------------------ 데이터 조회 ------------------
    useEffect(() => {
        UpgradeData();
    }, [page]);

    useEffect(() => {
        setPage(1);
        UpgradeData();
    }, [
        reload,
        selectedDate,
        selectedDate1,
        changeAmt,
        checkedTapGame,
        checkedJackpot,
        checkedConsume,
        checkedRandom,
        checkedAdmin,
    ]);

    const UpgradeData = async () => {
        setSpinner(true);

        // 체크된 유형에 따라 hisType 배열 구성
        const hisTypeArr = [];
        if (checkedTapGame) hisTypeArr.push(1);   // 탭게임
        if (checkedJackpot) hisTypeArr.push(2);   // 잭팟
        if (checkedConsume) hisTypeArr.push(3);   // 소비
        if (checkedRandom) hisTypeArr.push(4);    // 랜덤박스
        if (checkedAdmin) hisTypeArr.push(5);     // 관리자리워드

        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/log/gold', {
                params: {
                    page: page,
                    pageSize: 20,
                    startDate: formatDateTime(selectedDate),
                    endDate: formatDateTime(selectedDate1),
                    userId: search,
                    hisType: hisTypeArr,
                    changeAmt: changeAmt
                }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                console.log(tmp);
                setData(tmp?.data?.log ?? []);
                // 서버 응답에 totalPages or totalRecords 등 확인
                setTotalPage(tmp?.data?.pagination?.totalRecords ?? 0);
            }
        } catch (error) {
            console.log(error);
        }
        setSpinner(false);
    };

    // ------------------ 변동량 정렬 onClick ( 1→2→3→1 ) ------------------
    const handleChangeAmtClick = () => {
        setChangeAmt((prev) => {
            if (prev === 3) return 1; // 1로 돌아감
            return prev + 1;         // 1 -> 2 -> 3 -> 1
        });
    };

    // ------------------ 엑셀 다운로드 ------------------
    const excelBtn = async () => {
        // 유형 배열
        const hisTypeArr = [];
        if (checkedTapGame) hisTypeArr.push(1);
        if (checkedJackpot) hisTypeArr.push(2);
        if (checkedConsume) hisTypeArr.push(3);
        if (checkedRandom) hisTypeArr.push(4);
        if (checkedAdmin) hisTypeArr.push(5);

        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/log/gold/excel', {
                params: {
                    startDate: formatDateTime(selectedDate),
                    endDate: formatDateTime(selectedDate1),
                    userId: search,
                    hisType: hisTypeArr
                }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                excelData(tmp?.data?.log ?? []);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // ------------------ 엑셀 변환 ------------------
    const excelData = (exData) => {
        let arr = [];

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i];
                // his_type: 1=탭게임, 2=잭팟, 3=소비, 4=랜덤박스, 5=관리자리워드
                let typeStr = "";
                if (t.his_type === "1") typeStr = "탭게임";
                else if (t.his_type === "2") typeStr = "잭팟";
                else if (t.his_type === "3") typeStr = "소비";
                else if (t.his_type === "4") typeStr = "랜덤박스";
                else if (t.his_type === "5") typeStr = "관리자리워드";

                arr.push({
                    "no": t.id,
                    "로그날짜": t.his_date,
                    "유저아이디": t.user_id,
                    "로그유형": typeStr,
                    "변동량": t.his_amount,
                    "최종수량": t.his_balance,
                    "부연설명": t.his_desc,
                });
            }
        }
        Excel(arr);
    };

    // ------------------ JSX ------------------
    return (
        <div className="main">
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                {/* 검색 영역 */}
                <div className="member-1">
                    <div className={`member-2-search ${darkname}`}>
                        {/* 검색 구분 드롭다운 (ID) */}
                        <div
                            className={`member-1-select ${darkname}`}
                            onClick={() => setSelect((e) => !e)}
                        >
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {select ? (
                                <FontAwesomeIcon icon={faSortUp} />
                            ) : (
                                <FontAwesomeIcon icon={faSortDown} />
                            )}
                            {select && (
                                <>
                                    <div className="modal" onClick={() => setSelect(true)}></div>
                                    <div className={`member-1-select-box ${darkname}`}>
                                        <div
                                            onClick={() => {
                                                setSelectValue("ID");
                                                setSelect(true);
                                            }}
                                        >
                                            ID
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <FontAwesomeIcon icon={faWindowMinimize} className="line" />

                        {/* 검색 인풋 */}
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input
                                value={search}
                                onChange={onChangeSearch}
                                placeholder="Search"
                                onKeyDown={handleKeyPress}
                            />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="member-1-search-ico-3" />
                            {search.length > 0 && (
                                <FontAwesomeIcon
                                    icon={faCircleXmark}
                                    className="member-1-search-ico-2"
                                    onClick={() => setSearch("")}
                                />
                            )}
                        </div>
                    </div>

                    <div
                        className={`search-btn ${darkname}`}
                        onClick={() => onSubmitSearch()}
                    >
                        Search
                    </div>

                    {/* 날짜+시간 선택 */}
                    <div
                        className={`modal-3-1-left ${darkname}`}
                        style={{ marginLeft: "10px" }}
                    >
                        <div
                            className={dateBtn === 1 ? "modal-3-1-left-1 on" : "modal-3-1-left-1"}
                            onClick={() => {
                                setDateBtn(1);
                                const todayStart = new Date();
                                todayStart.setHours(0, 0, 0, 0);
                                const now = new Date();
                                setSelectedDate(todayStart);
                                setSelectedDate1(now);
                            }}
                        >
                            Today
                        </div>
                        <div
                            className={dateBtn === 5 ? "modal-3-1-left-1 on flex" : "modal-3-1-left-1 flex"}
                            onClick={() => setDateBtn(5)}
                            style={{ gap: "5px" }}
                        >
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="시작일/시간 선택"
                                shouldCloseOnSelect
                                minDate={new Date("2000-01-01")}
                                maxDate={selectedDate1}
                            />
                            <div>~</div>
                            <DatePicker
                                selected={selectedDate1}
                                onChange={(date) => setSelectedDate1(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="종료일/시간 선택"
                                shouldCloseOnSelect
                                minDate={selectedDate}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>
                </div>

                {/* 체크박스 + Excel버튼 */}
                <div className="excel" style={{ marginTop: "10px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "10px",
                        }}
                    >
                        {/* 탭게임 */}
                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "5px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checkedTapGame}
                                onChange={(e) => setCheckedTapGame(e.target.checked)}
                                style={{ transform: "scale(1.2)", marginRight: "3px" }}
                            />
                            <span>탭게임</span>
                        </label>
                        {/* 잭팟 */}
                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "5px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checkedJackpot}
                                onChange={(e) => setCheckedJackpot(e.target.checked)}
                                style={{ transform: "scale(1.2)", marginRight: "3px" }}
                            />
                            <span>잭팟</span>
                        </label>
                        {/* 소비 */}
                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "5px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checkedConsume}
                                onChange={(e) => setCheckedConsume(e.target.checked)}
                                style={{ transform: "scale(1.2)", marginRight: "3px" }}
                            />
                            <span>소비</span>
                        </label>
                        {/* 랜덤박스 */}
                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "5px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checkedRandom}
                                onChange={(e) => setCheckedRandom(e.target.checked)}
                                style={{ transform: "scale(1.2)", marginRight: "3px" }}
                            />
                            <span>랜덤박스</span>
                        </label>
                        {/* 관리자리워드 */}
                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "5px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checkedAdmin}
                                onChange={(e) => setCheckedAdmin(e.target.checked)}
                                style={{ transform: "scale(1.2)", marginRight: "3px" }}
                            />
                            <span>관리자리워드</span>
                        </label>
                    </div>
                    <div className={`excel-btn ${darkname}`} onClick={() => excelBtn()}>
                        Excel download
                    </div>
                </div>

                {/* 테이블 영역 */}
                <div className={`member-2 ${darkname}`}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "10%", minWidth: "100px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>로그 날짜</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>유저 아이디</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>로그유형</div>
                        {/* 변동량 정렬 onClick => 1->2->3->1 순환 */}
                        <div
                            className="table-sort"
                            onClick={handleChangeAmtClick}
                            style={{ width: "10%", minWidth: "100px", cursor: "pointer" }}
                        >
                            <span>변동량</span>
                            <span style={{ paddingTop: "1px" }}>
                                <span className="index_sort-btn__eWsx8">
                                    {/* 위쪽 화살표 */}
                                    <svg width="9" height="6" viewBox="0 0 5 3">
                                        <path
                                            className={changeAmt === 3 ? "fill-color" : ""}
                                            d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z"
                                            fill="#999"
                                        />
                                    </svg>
                                    {/* 아래쪽 화살표 */}
                                    <svg width="9" height="6" viewBox="0 0 5 3">
                                        <path
                                            className={changeAmt === 2 ? "fill-color" : ""}
                                            d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z"
                                            fill="#999"
                                        />
                                    </svg>
                                </span>
                            </span>
                        </div>
                        <div style={{ width: "10%", minWidth: "130px" }}>최종 수량</div>
                        <div style={{ width: "10%", minWidth: "250px" }}>부연설명</div>
                        <div>-</div>
                    </div>

                    <div className="table-body" style={{ minHeight: "600px" }}>
                        {spinner ? (
                            <div className="spinner-modal">
                                <SyncLoader color="#003577" />
                            </div>
                        ) : data.length === 0 ? (
                            <div className="data-nofound">
                                <img src="/img/img_nofound.png" alt="nofound-light" />
                                <img
                                    src="/img/img_nofound_dark.svg"
                                    style={{ display: "none" }}
                                    alt="nofound-dark"
                                />
                                <p>NO RECORDS FOUND.</p>
                            </div>
                        ) : (
                            <>
                                {data.map((a, i) => (
                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} />
                                ))}
                                <NewPage
                                    initialData={totalpage}
                                    page={page}
                                    setPage={setPage}
                                    maxFirstPage={20}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

// ------------------ 개별 Row ------------------
function MemberItem({ item, darkname, dark }) {
    // his_type: 1=탭게임, 2=잭팟, 3=소비, 4=랜덤박스, 5=관리자리워드
    const typeStr = (() => {
        if (item.his_type === "1") return "탭게임";
        if (item.his_type === "2") return "잭팟";
        if (item.his_type === "3") return "소비";
        if (item.his_type === "4") return "랜덤박스";
        if (item.his_type === "5") return "관리자리워드";
        return "";
    })();

    return (
        <div className={`table-body-tr ${darkname}`}>
            <div className="td" style={{ width: "10%", minWidth: "100px" }}>
                {item.id}
            </div>
            <div className="td" style={{ width: "10%", minWidth: "150px" }}>
                {item.his_date}
            </div>
            <div className="right td" style={{ width: "10%", minWidth: "120px" }}>
                {item.user_id}
            </div>
            <div className="td" style={{ width: "10%", minWidth: "150px" }}>
                {typeStr}
            </div>
            <div className="right td" style={{ width: "10%", minWidth: "100px" }}>
                {changeNum(item.his_amount)}
            </div>
            <div className="right td" style={{ width: "10%", minWidth: "130px" }}>
                {changeNum(item.his_balance)}
            </div>
            <div className="left td" style={{ width: "10%", minWidth: "250px" }}>
                {item.his_desc}
            </div>
            <div className="td">-</div>
        </div>
    );
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '포인트 로그';

    const headerRow = ["no", "로그날짜", "유저아이디", "로그유형", "변동량", "최종수량", "부연설명"];
    const bodyRows = excelData.map((data) => [data.no, data.로그날짜, data.유저아이디, data.로그유형, Number(data.변동량), Number(data.최종수량), data.부연설명]);

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // 컬럼 너비
    ws['!cols'] = Array(headerRow.length).fill({ wpx: 120 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default LogPoint;
